module.exports = __webpack_public_path__ + "img/audio_play.b01f1d9b.svg";